import React, { useContext, useEffect, useState } from 'react';
import { BrowserRouter, Route } from 'react-router-dom';
import { LoginScreen } from 'pages/LoginScreen';
import { PrivateRoute } from './PrivateRoute';
import { DashboardScreen } from 'pages/DashboardScreen';
import { Callback } from '../components/auth/Callback';
import { Logout } from '../components/auth/Logout';
import { LogoutCallback } from '../components/auth/LogoutCallback';
import { SilentRenew } from '../components/auth/SilentRenew';
import { NotFoundPage } from '../pages/NotFoundPage';
import { authActions } from '../store/auth/actions';
import { useDispatch, useSelector } from 'react-redux';
import { AuthContext } from '../providers/AuthProvider';
import { ROUTES } from '../config/routes';
import { IAppState } from '../store';
import Api from '../api';
import i18n from '../i18n';

const SERVER_TO_I18N_LANGUAGE_MAP: Record<string, string> = {
  'pt': 'po',
  'es': 'es',
  'ch': 'ch',
  'it': 'it',
  'de': 'de',
  'fr': 'fr',
  'en': 'en'
};

export const GlobalRouter = () => {
  const dispatch = useDispatch();
  const { getUser, isAuthenticated } = useContext(AuthContext);
  const userRole = useSelector(
    (state: IAppState) => state.auth.profile?.UserRoleName,
  );
  const [languageLoaded, setLanguageLoaded] = useState(false);

  useEffect(() => {
    try {
      if (isAuthenticated() && !userRole) {
        getUser().then(user => {
          if (user) {
            dispatch(authActions.authorizeUserAction(user?.profile));
          }
        });
      }
    } catch (e) {
      console.log(e);
    }
  }, [dispatch, getUser, isAuthenticated, userRole]);

  // Fetch and apply user's default language after login.
  // Depends on userRole because it changes from null to a value after auth,
  // which re-triggers the effect at the right moment.
  useEffect(() => {
    if (!isAuthenticated() || languageLoaded) return;

    Api(true)
      .get('/api/User/GetDefaultLanguage')
      .then(response => {
        const languageCode = response.data;
        localStorage.setItem('lang', languageCode);

        const i18nLang = SERVER_TO_I18N_LANGUAGE_MAP[languageCode] || languageCode;
        i18n.changeLanguage(i18nLang).then(() => setLanguageLoaded(true));
      })
      .catch(() => setLanguageLoaded(true));
  }, [userRole, languageLoaded]);

  return (
    <BrowserRouter basename={'/'}>
      <div className="global-wrapper">
        <Route exact path={ROUTES.home} component={LoginScreen} />
        <Route path={ROUTES.callback} component={Callback} />
        <Route exact path={ROUTES.logout} component={Logout} />
        <Route exact path={ROUTES.logoutCallback} component={LogoutCallback} />
        <Route exact path={ROUTES.silentRenew} component={SilentRenew} />
        <Route exact path={ROUTES.notFound} component={NotFoundPage} />
        <PrivateRoute path={ROUTES.dashboard} component={DashboardScreen} />
      </div>
    </BrowserRouter>
  );
};
